export default "__VITE_ASSET__Btxa0V5i__"